module.exports = __webpack_public_path__ + "static/media/LIZ-splash.cc452630.png";